// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { Base64 } from '../../../utils/base64';
import type { ExcludeMethodsDeep } from '../../../utils/types';

export class PdfPart {
  readonly template: string | null;
  readonly staticContent: Base64;

  constructor(data: { [key: string]: any } = {}) {
    this.template = data.template === undefined ? null : data.template;
    this.staticContent = data.staticContent === undefined ? '' : data.staticContent;
  }

  static zero(): PdfPart {
    const zeroValues: ExcludeMethodsDeep<PdfPart> = {
      template: null,
      staticContent: '',
    };
    return new PdfPart(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PdfPartWireFormat = {
  template: string | null;
  staticContent: string;
};

type NewPdfPartProps = PartialDeep<PdfPart, { recurseIntoArrays: true }>;
export const NewPdfPart: (props: NewPdfPartProps) => PdfPart = (props) => new PdfPart(props);

type NewPdfPartFromWireFormatProps = PartialDeep<PdfPartWireFormat, { recurseIntoArrays: true }>;
export const NewPdfPartFromWireFormat: (props: NewPdfPartFromWireFormatProps) => PdfPart = (
  props,
) => new PdfPart(props);
